import { PAGE_HOME_INCLUSIONE, PAGE_HOME_URL, PAGE_ORIENTAMENTO_SCOLASTICO_ED_EXTRA } from 'types/url';

export const breadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Orientamento scolastico ed extrascolastico',
    url: PAGE_ORIENTAMENTO_SCOLASTICO_ED_EXTRA,
  },
  {
    slash: 'HO BISOGNO DI ORIENTAMENTO',
    url: '',
  },
];

export const title = 'WeMi - Inclusione - Orientamento scolastico ed extrascolastico - Ho bisogno di orientamento';
export const description = 'Orientamento servizio scolastico ed extrascolastico';
export const keywords = 'welfare, milano, servizi, servizio, Orientamento scolastico ed extrascolastico ho bisogno di orientamento , servizio Orientamento scolastico ed extrascolastico, informazioni orientamento scolastico ed extrascolastico';
